<script>
import broker from "../utils/broker";

import FooterAbout from "@/components/footer-about";
import FooterLink from "@/components/footer-link";
import ContactWidget from "@/components/kontak-widget";
import SocialWidget from "@/components/social-widget";

import data from "../data/footer.json";
export default {
  components: {
    FooterAbout,
    FooterLink,
    ContactWidget,
    SocialWidget,
  },
  props: ["bgFooter"],
  data() {
    return {
      contact: {
        address: {},
        phone: {},
        email: {},
        facebook: {},
        twitter: {},
        instagram: {},
        linkedin: {},
        youtube: {},
      },
      footerDesc: {},
      meta: {},
      data,
    };
  },
  mounted() {
    broker.fetch
      .get(
        `/webschool/content?types[]=address&types[]=phone&types[]=email&types[]=footer_desc&types[]=social_youtube&types[]=social_facebook&types[]=social_instagram&types[]=social_twitter&types[]=social_linkedin&status=published`
      )
      .then((res) => {
        const data = res.data.data;
        this.contact.address = data.find((o) => o.type.name === "address");
        this.contact.phone = data.find((o) => o.type.name === "phone");
        this.contact.email = data.find((o) => o.type.name === "email");
        this.contact.facebook = data.find(
          (o) => o.type.name === "social_facebook"
        );
        this.contact.instagram = data.find(
          (o) => o.type.name === "social_instagram"
        );
        this.contact.twitter = data.find(
          (o) => o.type.name === "social_twitter"
        );
        this.contact.linkedin = data.find(
          (o) => o.type.name === "social_linkedin"
        );
        this.contact.youtube = data.find(
          (o) => o.type.name === "social_youtube"
        );
        this.footerDesc = data.find((o) => o.type.name === "footer_desc");
      });

    broker.fetch.get(`/webschool/meta`).then((res) => {
      this.meta = res.data.school;
    });
  },
};
</script>
<template>
  <div class="footer-area green-bg">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="footer-content-wrapper section-space--inner--50">
            <!-- <div class="row mb-5">
                            <div class="col-xl-6 col-lg-3 col-md-4">
                                <img src="assets/img/logo/logo-light-small.png" class="img-fluid logo-footer" alt="logo">
                            </div>
                            <div class="col-xl-6 float-right col-lg-3 col-md-4">
                                <div class="social-links social-links--white-topbar mt-3 float-sm-right ">
                                    <ul>
                                        <li>
                                            <a href="#" target="_blank" class="font-size-17">ikuti kami</i></a>
                                        </li>
                                        <li>
                                            <a href="#" target="_blank"><i class="font-size-20 fa fa-facebook-square"></i></a>
                                        </li>
                                        <li>
                                            <a href="#" target="_blank"><i class="font-size-20 fa fa-twitter"></i></a>
                                        </li>
                                        <li>
                                            <a href="#" target="_blank"><i class="font-size-20 fa fa-instagram"></i></a>
                                        </li>
                                        <li>
                                            <a href="#" target="_blank"><i class="font-size-20 fa fa-whatsapp"></i></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div> -->
            <div class="row">
              <div class="col-xl-5 col-lg-3 col-md-4">
                <!-- <div class="footer-intro-wrapper">
                                    <h4 class="footer-widget__title">{{data.quote.title}}</h4>
                                    <div class="footer-desc text-white font-size-13">
                                        {{ data.quote.content }}
                                    </div>
                                </div> -->
                <div class="row">
                  <div class="col-lg-4 text-center">
                    <img
                      :src="meta.image"
                      class="img-fluid logo-footer"
                      alt="logo"
                    />
                  </div>
                  <div class="col-lg-8">
                    <div class="footer-intro-wrapper">
                      <h4 class="footer-widget__title text-white">
                        {{ meta.name }}
                      </h4>
                      <div class="footer-desc font-size-13 text-white">
                        {{
                          footerDesc.body
                            ? footerDesc.body.replace(/<\/?[^>]+(>|$)/g, "")
                            : ""
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-lg-3 col-md-4">
                <div class="footer-intro-wrapper">
                  <h4 class="footer-widget__title text-white">
                    Kontak
                  </h4>
                  <div class="footer-desc font-size-13 text-white">
                    <p class="font-size-13">
                      <i class="fa fa-phone font-size-17 text-white mr-2"></i>
                      {{ meta.phone }}
                    </p>
                    <p class="font-size-13">
                      <i
                        class="fa fa-envelope font-size-17 text-white mr-2"
                      ></i>
                      {{ meta.email }}
                    </p>
                    <p class="font-size-13">
                      <i
                        class="fa fa-map-marker font-size-17 text-white mr-2"
                      ></i>
                      {{ meta.address }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4">
                <div class="footer-intro-wrapper">
                  <h4 class="footer-widget__title text-white">
                    Ikuti Kami
                  </h4>
                  <div class="footer-desc font-size-13">
                    <div
                      class="social-links social-links--white-topbar mt-3 float-sm-left"
                    >
                      <ul>
                        <li>
                          <a :href="contact.facebook.body" target="_blank"
                            ><i class="font-size-20 fa fa-facebook-square"></i
                          ></a>
                        </li>
                        <li>
                          <a :href="contact.twitter.body" target="_blank"
                            ><i class="font-size-20 fa fa-twitter"></i
                          ></a>
                        </li>
                        <li>
                          <a :href="contact.instagram.body" target="_blank"
                            ><i class="font-size-20 fa fa-instagram"></i
                          ></a>
                        </li>
                        <li>
                          <a :href="contact.linkedin.body" target="_blank"
                            ><i class="font-size-20 fa fa-linkedin"></i
                          ></a>
                        </li>
                        <li>
                          <a :href="contact.youtube.body" target="_blank"
                            ><i class="font-size-20 fa fa-youtube"></i
                          ></a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-copyright-wrapper-green">
      <div class="footer-copyright text-center text-white">
        © Copyright All right reserved | Designed By Onklas | Powered By Onklas
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.bg-footer {
  background-color: #212529;
}
.logo-footer {
  margin-left: -20px;
}
</style>
